<template>
  <div class="splashscreens-list">
    <div class="grid">
      <div v-if="splashscreens.length && !loading">
        <SplashscreenCard v-for="(splashscreen) in splashscreens" :splashscreenInfo="splashscreen" :editPermission="editPermission"
         :key="splashscreen.id" @openFullInfo="openStoryModal(splashscreen)"
          @openEdit="openStoryEdit(splashscreen.id)" />
      </div>
      <div v-else>
        <SplashscreenCardSkeleton v-for="n in 10" :key="n" />
      </div>
    </div>
  </div>
</template>
<script>
import SplashscreenCard from '@/views/apps/media/components/splashscreens/splashscreenCard.vue'
import SplashscreenCardSkeleton from '@/views/apps/media/components/splashscreens/splashscreenCardSkeleton.vue'
import MediaService from '@/services/api/apiMediaService'
// import ViewscreenService from '@/services/api/apiViewscreenService'
export default {
  name: 'Splashscreen-list',
  components: {
    SplashscreenCard,
    SplashscreenCardSkeleton,
  },
  props: {
    editPermission: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
    },
    filters: {
      type: Object,
    },
  },
  data() {
    return {
      splashscreens: [],
      drag: false,
      loading: false,
      apps: undefined,
      isPopupModalOpen: false,
      popupObject: undefined,
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  async created() {
    await this.listUpdate()
  },
  watch: {
    filters: {
      handler: async function() {
        await this.listUpdate()
      },
      deep: true,
    },
  },
  methods: {
    async listUpdate() {
      try {
        this.loading = true
        await this.getSplashscreens()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async getSplashscreens() {
      const { name, active, localizationId, applicationId } = this.filters
      const searchParams = new URLSearchParams()
      searchParams.append('active', active)

      if (typeof localizationId !== 'undefined') {
        searchParams.append('lang_ids', [localizationId])
      }

      if (typeof applicationId !== 'undefined') {
        searchParams.append('app_ids[]', applicationId)
      }

      if (typeof name !== 'undefined') {
        searchParams.append('name', name)
      }

      try {
        this.loading = true

        const splashscreensResponse = await MediaService.getSplashscreens(searchParams)

        if (!splashscreensResponse?.data?.data) {
          this.$notification.error({
            message: 'Something went wrong. Please try again later.',
          })
        }

        this.splashscreens = splashscreensResponse.data.data
      } catch (err) {
        let errorMessage = 'Something went wrong. Please try again later.'

        if (err.response?.data?.error?.message) {
          errorMessage = err.response.data.error.message
        } else if (err.message) {
          errorMessage = err.message
        }

        this.$notification.error({
          message: errorMessage,
        })
      } finally {
        this.loading = false
      }
    },

    // async sortsplashscreens() {
    //   const popupSort = this.splashscreens.map((banner, index, promoArr) => {
    //     return {
    //       popup_banner_id: banner.id,
    //       sort: index + 1,
    //     }
    //   })
    //   const sort = { sort: popupSort }
    //   try {
    //     await PopupService.sortsplashscreens(this.filters.applicationId, sort)
    //     this.$notification.success({
    //       message: 'Sucessfully sorted',
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    //   this.drag = false
    // },
  },
}
</script>
